<template>
  <div
    class="client-province-city"
  >
    <div style="display:inline-block;width:200px;">
      <div style="height:30px">
        省份
      </div>
      <a-select
        :disabled="proAndCityDisabled"
        placeholder="请选择省份"
        :value="province"
        class="province"
        @select="handleSelect"
        @change="handleChangeProvince"
      >
        <a-select-option
          v-for="item in provinceData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </div>
    <div
      v-show="cityShow"
      style="display:inline-block;width:242px;margin-left:32px;"
    >
      <div style="height:30px">
        城市
      </div>
      <a-select
        :disabled="proAndCityDisabled"
        placeholder="请选择城市"
        :value="city"
        @change="handleChangeCity"
      >
        <a-spin
          v-if="cityLoading"
          slot="notFoundContent"
          size="small"
        />
        <a-select-option
          v-for="item in cityData"
          v-else
          :key="item.id"
          :value="item.id"
        >
          {{ item.title }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'proAndCityDisabled'],
  data() {
    const value = this.value || {};
    return {
      provinceData: [],
      cityData: [],
      province: value.province,
      city: value.city,
      path: '',
      cityLoading: true,
      cityShow: false,
    };
  },
  watch: {
    value(val = {}) {
      this.province = val.province;
      this.city = val.city;
    },
    province(val) {
      this.handleSelect(val);
      this.city = this.$props.value.city;
    },
  },
  async mounted() {
    // 获取省市
    let result = await this.$http.post('/system/getRegionList');
    if (result.data.status === 1) {
      this.provinceData = result.data.data;
    }
  },

  methods: {
    // 选中省份
    async handleSelect(key) {
      this.city = '';
      if(key>4){
        this.cityShow = true;
      }else{
        this.cityShow = false;
      }
      let result = await this.$http.post('/system/getRegionList', {
        pid: key,
      });
      if (result.data.status === 1) {
        this.cityLoading = false;
        this.cityData = result.data.data;
      }
    },
    // change 省份
    handleChangeProvince(value) {
      this.$emit('change', {
        province: value,
        city: this.city,
      });
    },
    // change 城市
    handleChangeCity(value) {
      this.$emit('change', {
        province: this.province,
        city: value,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-province-city{
.province{

}
}
</style>
